module.exports = __webpack_public_path__ + "img/PT1.d9dbb819.png";